// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FishFilledSvg from "@fishx/icons-svg/es/asn/FishFilled";
import FishxIcon from '../components/FishxIcon';

var FishFilled = function FishFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FishFilledSvg
  }));
};

FishFilled.displayName = 'FishFilled';
export default React.forwardRef(FishFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FishFilled.js
// module id = 2781
// module chunks = 0